// import Typography from "../Typography/Typography"
// import styles from "./style.module.css"
// import { ModalClose } from "../../assets/svgs"
// import { OrderItems } from "../orderItems"

// interface orderProp {
//     id?: string
//     openModal?: boolean
//     toggle: () => void
// }

// interface CartItem {
//     id: number;
//     name: string;
//     category: string;
//     stockNumber: number;
//     colour: string;
//     price: number;
//     image: string;
//     initialQuantity: number;
//     status: "Pending" | "Confirmed" | "Processed";
// }

// export const OrderModal: React.FC<orderProp> = ({
//     id,
//     openModal = true,
//     toggle,
// }) => {

//     const cartData: CartItem[] = [
//         {
//             id: 1,
//             name: "Wireless Bluetooth Headphones",
//             category: "Electronics",
//             stockNumber: 7,
//             colour: "Black",
//             price: 89.99,
//             image:
//                 "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&h=200&fit=crop&crop=center",
//             initialQuantity: 1,
//             status: "Pending",
//         },
//         {
//             id: 2,
//             name: "Running Shoes",
//             category: "Footwear",
//             stockNumber: 15,
//             colour: "Red",
//             price: 59.5,
//             image:
//                 "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
//             initialQuantity: 2,
//             status: "Confirmed",
//         },
//         {
//             id: 3,
//             name: "Smartwatch",
//             category: "Electronics",
//             stockNumber: 10,
//             colour: "Silver",
//             price: 120,
//             image:
//                 "https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?w=200&h=200&fit=crop&crop=center",
//             initialQuantity: 1,
//             status: "Processed",
//         },
//     ];


//     if (!openModal) {
//         return null
//     }

//     return (
//         <div className={styles.overLay}>

//             <div className={styles.container}>

//                 <button
//                     className={styles.close}
//                     onClick={() => { toggle() }}
//                 >
//                     <img className={styles.closeModal} src={ModalClose} alt="" />
//                 </button>

//                 <div className={styles.content}>

//                     <div className={styles.header}>

//                         <Typography
//                             variant="heading5"
//                         >
//                             Order Id: #{id}
//                         </Typography>

//                     </div>

//                     <hr className={styles.line} />

//                     <div className={styles.profileContainer}>

//                         <div className={styles.profileSubContainer}>

//                             <div className={styles.field}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Placed:
//                                 </Typography>

//                                 <Typography>
//                                     2h ago
//                                 </Typography>
//                             </div>

//                             <div className={styles.field}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Customer:
//                                 </Typography>

//                                 <Typography>
//                                     Grace Amarachi
//                                 </Typography>
//                             </div>

//                             <div className={styles.field}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Street Name:
//                                 </Typography>

//                                 <Typography>
//                                     Thomson Akpabio
//                                 </Typography>
//                             </div>

//                             <div className={styles.field}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     State/City:
//                                 </Typography>

//                                 <Typography>
//                                     Uyo
//                                 </Typography>
//                             </div>

//                         </div>

//                         <div className={styles.profileSubContainer}>

//                             <div className={styles.field}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Phone:
//                                 </Typography>

//                                 <Typography>
//                                     +234 801 234 5678
//                                 </Typography>
//                             </div>

//                             <div className={styles.field}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Email:
//                                 </Typography>

//                                 <Typography>
//                                     grace@email.com
//                                 </Typography>
//                             </div>

//                             <div className={styles.field}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Postal Code:
//                                 </Typography>

//                                 <Typography>
//                                     1234567
//                                 </Typography>
//                             </div>

//                             <div className={styles.fieldAddress}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Full Address:
//                                 </Typography>

//                                 <div className={styles.addressContainer}>
//                                     <Typography>
//                                         Shelter Afrique, Thomson Akpabio street, Uyo Akwa Ibom
//                                     </Typography>
//                                 </div>
//                             </div>

//                         </div>

//                     </div>

//                     <hr className={styles.line} />

//                     <div className={styles.ItemContainer}>

//                         {cartData.map((item) => (
//                             <OrderItems
//                                 id={item.id}
//                                 name={item.name}
//                                 category={item.category}
//                                 stockNumber={item.stockNumber}
//                                 colour={item.colour}
//                                 price={item.price}
//                                 image={item.image}
//                                 initialQuantity={item.initialQuantity}
//                                 status={item.status}
//                             />
//                         ))}
//                     </div>

//                     <hr className={styles.line} />

//                     <div className={styles.priceContainer}>

//                         <div className={styles.total}>
//                             <div className={styles.totalTextContainerLeft}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Subtotal
//                                 </Typography>
//                             </div>

//                             <div className={styles.totalTextContainerRight}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     $2,847.96
//                                 </Typography>
//                             </div>

//                         </div>

//                         <div className={styles.total}>

//                             <div className={styles.totalTextContainerLeft}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Discount
//                                 </Typography>
//                             </div>

//                             <div className={styles.totalTextContainerRight}>
//                                 <Typography
//                                     variant="heading6"
//                                     className={styles.discountPrice}
//                                 >
//                                     $0
//                                 </Typography>
//                             </div>

//                         </div>

//                         <div className={styles.total}>

//                             <div className={styles.totalTextContainerLeft}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     Total
//                                 </Typography>
//                             </div>

//                             <div className={styles.totalTextContainerRight}>
//                                 <Typography
//                                     variant="heading6"
//                                 >
//                                     $2,847.96
//                                 </Typography>
//                             </div>

//                         </div>

//                     </div>

//                 </div>

//             </div>

//         </div>
//     )
// }



import React from 'react';
import styles from './style.module.css';
import Typography from '../Typography/Typography';
import { StatusSelector, Option } from '../StatusSelector';

interface OrderItem {
  product_id: string;
  product_name: string;
  quantity: number;
  price: number;
  item_total: number;
  image?: string;
  color?: string;
  size?: string;
}

interface OrderModalProps {
  id: string;
  openModal: boolean;
  toggle: () => void;
  orderData?: {
    _id: string;
    created_at: string;
    customer_name?: string;
    phone?: string;
    email?: string;
    shipping_address: {
      street_name: string;
      city_or_state: string;
      postal_code: string;
      full_address: string;
    };
    items: OrderItem[];
    total_amount: number;
    order_status: string;
    discount?: number;
  };
}

export const OrderModal: React.FC<OrderModalProps> = ({ 
  id, 
  openModal, 
  toggle,
  orderData 
}) => {
  if (!openModal) return null;

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / 3600000);
    
    if (diffHours < 24) {
      return `${diffHours}h ago`;
    } else {
      const diffDays = Math.floor(diffMs / 86400000);
      return `${diffDays}d ago`;
    }
  };

  const getStatusLabel = (status: string): "Confirmed" | "Pending" | "Processed" => {
    if (!status) return "Pending";
    const s = status.toLowerCase();
    if (s === "confirmed") return "Confirmed";
    if (s === "pending") return "Pending";
    if (s === "processed" || s === "shipped" || s === "delivered") return "Processed";
    return "Pending";
  };

  const getOptions: Option[] = [
    { value: "Confirmed", label: "Confirmed" },
    { value: "Pending", label: "Pending" },
    { value: "Processed", label: "Processed" },
  ];

  const subtotal = orderData?.items.reduce((sum, item) => sum + item.item_total, 0) || 0;
  const discount = orderData?.discount || 0;
  const total = orderData?.total_amount || subtotal - discount;

  return (
    <div className={styles.modalOverlay} onClick={toggle}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <Typography variant="heading3" className={styles.modalTitle}>
            Order Id: #{id.slice(-4).toUpperCase()}
          </Typography>
          <button title='Toggle Button' className={styles.closeButton} onClick={toggle}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.orderInfo}>
            <div className={styles.infoGrid}>
              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  Placed:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.created_at ? formatDate(orderData.created_at) : 'N/A'}
                </Typography>
              </div>

              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  Phone:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.phone || '+234 801 234 5678'}
                </Typography>
              </div>

              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  Customer:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.customer_name || 'Grace Amarachi'}
                </Typography>
              </div>

              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  Email:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.email || 'grace@email.com'}
                </Typography>
              </div>

              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  Street Name:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.shipping_address?.street_name || 'Thomson Akpabio'}
                </Typography>
              </div>

              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  Postal Code:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.shipping_address?.postal_code || '1234567'}
                </Typography>
              </div>

              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  State/City:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.shipping_address?.city_or_state || 'Uyo'}
                </Typography>
              </div>

              <div className={styles.infoItem}>
                <Typography variant="bodyRegular" className={styles.infoLabel}>
                  Full Address:
                </Typography>
                <Typography variant="bodyRegular" className={styles.infoValue}>
                  {orderData?.shipping_address?.full_address || 
                   'Shelter Afrique, Thomson Akpabio street, Uyo Akwa Ibom'}
                </Typography>
              </div>
            </div>
          </div>

          <div className={styles.itemsList}>
            {orderData?.items.map((item, index) => (
              <div key={index} className={styles.orderItem}>
                <div className={styles.itemImageContainer}>
                  <img 
                    src={item.image || 'https://via.placeholder.com/80x80'} 
                    alt={item.product_name}
                    className={styles.itemImage}
                  />
                </div>
                
                <div className={styles.itemDetails}>
                  <Typography variant="bodyRegular" className={styles.itemName}>
                    {item.product_name}
                  </Typography>
                  <Typography variant="bodySmall" className={styles.itemCategory}>
                    Shoe
                  </Typography>
                  <div className={styles.itemAttributes}>
                    {item.color && (
                      <span className={styles.attributeBadge}>
                        {item.color}
                      </span>
                    )}
                    {item.size && (
                      <span className={styles.attributeBadge}>
                        {item.size}
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.itemQuantity}>
                  <Typography variant="bodyRegular" className={styles.quantityText}>
                    {item.quantity}
                  </Typography>
                </div>

                <div className={styles.itemPrice}>
                  <Typography variant="bodyRegular" className={styles.priceText}>
                    ${item.item_total.toFixed(2)}
                  </Typography>
                </div>

                <div className={styles.itemStatus}>
                  <StatusSelector
                    value={getStatusLabel(orderData.order_status)}
                    options={getOptions}
                    onChange={(val) => console.log("Status changed:", val)}
                  />
                </div>
              </div>
            )) || (
              <div className={styles.emptyItems}>
                <Typography variant="bodyRegular" className={styles.emptyText}>
                  No items in this order
                </Typography>
              </div>
            )}
          </div>

          <div className={styles.orderSummary}>
            <div className={styles.summaryRow}>
              <Typography variant="bodyRegular" className={styles.summaryLabel}>
                Subtotal
              </Typography>
              <Typography variant="bodyRegular" className={styles.summaryValue}>
                ${subtotal.toFixed(2)}
              </Typography>
            </div>

            <div className={styles.summaryRow}>
              <Typography variant="bodyRegular" className={styles.summaryLabel}>
                Discount
              </Typography>
              <Typography variant="bodyRegular" className={styles.discountValue}>
                ${discount.toFixed(2)}
              </Typography>
            </div>

            <div className={styles.summaryDivider}></div>

            <div className={styles.summaryRow}>
              <Typography variant="heading4" className={styles.totalLabel}>
                Total
              </Typography>
              <Typography variant="heading4" className={styles.totalValue}>
                ${total.toFixed(2)}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};